import script from "./ProcessHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessHistory.vue?vue&type=script&setup=true&lang=js"

import "./ProcessHistory.vue?vue&type=style&index=0&id=6635a79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6635a79a"]])

export default __exports__